module.exports = __webpack_public_path__ + "static/img/sub_page_banner_10.5c768e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_10.jpg
// module id = QW9V
// module chunks = 0